// extracted by mini-css-extract-plugin
export var cabinet_company = "menu-module--cabinet_company--ZuBqP";
export var cabinet_footer = "menu-module--cabinet_footer--ba2p7";
export var cabinet_head = "menu-module--cabinet_head--CT3na";
export var cabinet_img = "menu-module--cabinet_img--ZdXqz";
export var cabinet_item = "menu-module--cabinet_item--qC7J3";
export var cabinet_mail = "menu-module--cabinet_mail--O468c";
export var cabinet_name = "menu-module--cabinet_name--Txk2z";
export var cabinet_nav = "menu-module--cabinet_nav--Ps25W";
export var dropdown = "menu-module--dropdown--TTe-2";
export var dropdown_body = "menu-module--dropdown_body--jxD+N";
export var logout = "menu-module--logout--1z0WJ";
export var material_icons = "menu-module--material_icons--VfPR6";